<template>
    <div class="child">
        <el-form label-width="90px" ref="formData" :model="formData">
            <!-- 个人信息 -->
            <injectInfo :formData="formData"></injectInfo>
            <!-- 既往病史 -->
            <injectIll :formData="formData"></injectIll>
            <h5>治疗意见</h5>
            <div class="card">
                <el-form-item label="注射治疗">
                    <el-checkbox-group @change="testSX" v-model="formData.injectionTreatment">
                        <el-checkbox v-for="(item,index) in injectNeeds" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他" class="double">
                    <el-input v-model.trim="formData.treatmentOther" style="width:95%;" placeholder="请输入其他治疗意见"></el-input>
                </el-form-item>
            </div>
            <h5>微创治疗</h5>
            <div class="card">
                <el-form-item label="一、注射前检查" label-width="140px" class="double">
                    <el-input @input="testSX" v-model.trim="formData.injectionInspect" style="width:95%;" placeholder="请输入"></el-input>
                </el-form-item>
                <div class="flex">
                    <div class="flex left">
                        <div>
                            <el-form-item label="1.肉毒素注射" label-width="140px" class="injectFlex">
                                <el-checkbox-group @change="testSX" v-model="formData.injectionType1">
                                    <el-checkbox v-for="(item,index) in arr" :key="index" :label="item.id">
                                        <span>{{item.name}}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <div style="width:150px;">
                                    <el-input type="textarea" v-model.trim="formData.injectionTypeOther1" placeholder="请输入其他"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="3.玻璃酸酶注射" label-width="140px" class="injectFlex">
                                <el-checkbox-group @change="testSX" v-model="formData.injectionType3">
                                    <el-checkbox v-for="(item,index) in arr3" :key="index" :label="item.id">
                                        <span>{{item.name}}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="4.嗨体注射" label-width="140px" class="injectFlex">
                                <!-- <el-form-item label=""> -->
                                <el-checkbox-group @change="testSX" v-model="formData.injectionType4">
                                    <el-checkbox v-for="(item,index) in arr2" :key="index" :label="item.id">
                                        <span>{{item.name}}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <!-- </el-form-item> -->
                                <div style="width:150px;">
                                    <el-input type="textarea" v-model.trim="formData.injectionTypeOther4" placeholder="请输入其他"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="2.玻尿酸/胶原蛋白填充" label-width="120px" class="injectFlex">
                                <el-checkbox-group @change="testSX" v-model="formData.injectionType2">
                                    <el-checkbox v-for="(item,index) in arr1" :key="index" :label="item.id">
                                        <span>{{item.name}}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <div style="width:150px;">
                                    <el-input type="textarea" v-model.trim="formData.injectionTypeOther2" placeholder="请输入其他"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="right">
                        <imgList ref="imgList" @boxSon="changeToSon" :formData="formData"></imgList>
                        <!-- <img src="../../assets/img/people.png" alt="" class="injectImg"> -->
                    </div>
                </div>
                <el-form-item label-width="60px">
                    <div>三、注射后注意事项</div>
                    <div>1.注射部位4小时内不能碰水;一周内避免对注射部位按摩、搓揉及热敷。</div>
                    <div>2.咬肌注射后少吃应韧类食物,减少咀嚼动作。</div>
                    <div>3.肉毒素注射后一般2周左右逐见成效,注射局部偶尔会有轻度肿胀、瘀斑或头痛,但短期内会消失;</div>
                    <div>禁止使用氨基糖苷类药物;注射部位2周内避免做激光治疗。</div>
                    <div>4.玻尿酸注射后偶尔局部会有轻度肿胀、瘀斑,一般一周内会消失,如不消失或有其它不适,注射后</div>
                    <div>一周左右复查。注射部位一个月内避免做激光治疗。</div>
                    <div>5.术后如需做面部其他治疗前,需告知医生曾经做过上述治疗。 </div>
                    <div class="little">6.其他 <el-input v-model.trim="formData.other" placeholder="请输入"></el-input>
                    </div>
                </el-form-item>

            </div>
        </el-form>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="doAddgoods()">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import injectIll from './illness'
import injectInfo from './info'
import imgList from '../buckle/imgList'
import { dataURLtoFile } from "../../assets/js/base"
import html2canvas from 'html2canvas'
export default {
    props: ['formData'],
    components: {
        injectIll, injectInfo, imgList
    },
    computed: {
        ...mapState(['instruments', 'injectNeeds', 'arr', 'arr1', 'arr2', 'arr3']),
    },
    data() {
        return {
            name: '',
            injectionPosition: '',
            file: '',
        }
    },
    methods: {
        changeToSon(val) {
            // console.log(val);
            this.injectionPosition = val
            // dataURLtoFile(this.scenePhoto,'文件名');
        },
        testSX() {
            this.$forceUpdate()
        },
        close() {
            this.$emit('close')
        },
        doAddgoods() {
            // 获取需要传给后台的图片
            html2canvas(this.$refs.imgList.$refs.imageWrapper, {
                backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
                useCORS: true, //支持图片跨域
                scale: 1, //设置放大的倍数
            }).then((canvas) => {
                // 把生成的base64位图片上传到服务器,生成在线图片地址
                let url = canvas.toDataURL('image/png') // toDataURL: 图片格式转成 base64
                this.imgUrl = url
                this.file = dataURLtoFile(this.imgUrl, '人像.png');
                // console.log(this.file);
                // console.log(this.injectionPosition);
                // console.log(this.formData);
                let data = {
                    id: this.formData.id,
                    musInformationId: this.formData.musInformationId,
                    patientName: this.formData.patientName,//姓名
                    sex: this.formData.sex,//顾客性别
                    age: this.formData.age,//年龄
                    idCode: this.formData.idCode,//身份证号码
                    address: this.formData.address,//地址
                    mobile: this.formData.mobile,//联系方式
                    cadCode: this.formData.cadCode,//客户卡号
                    caseCode: this.formData.caseCode,//病历号
                    earId: this.formData.earId,//院区id
                    earName: this.formData.earName,//院区名称
                    doctorName: this.formData.doctorName,//医生姓名
                    doctorNo: this.formData.doctorNo,//医生编号
                    sknFloor: this.formData.sknFloor,//楼层
                    operationTime: this.formData.sknDate,//手术日期
                    musProjectId: this.formData.musProjectId,//项目编号
                    musProjectName: this.formData.musProjectName,//划扣项目名称
                    chiefComplaint: this.formData.chiefComplaint,//主诉
                    latestMedicalHistory: this.formData.latestMedicalHistory,//现病史
                    // 既往病史
                    skinDisease: this.formData.skinDisease,//严重皮肤病 0、无 1、有
                    diabetes: this.formData.diabetes,//糖尿病 0、无 1、有
                    autoimmuneDisease: this.formData.autoimmuneDisease,//自身免疫病 0、无 1、有
                    coagulationDisorders: this.formData.coagulationDisorders,//凝血功能障碍  0、无 1、有
                    isFirst: this.formData.isFirst,//是否在本院首次注射药物或者填充物 0、无 1、有
                    allergyHistory: this.formData.allergyHistory,//药物/食物过敏史 0、无 1、有
                    allergy: this.formData.allergy,//有药物/食物过敏史（输入过敏内容）
                    period: this.formData.period,//是否经期 0、无 1、有
                    pregnant: this.formData.pregnant,//是否怀孕  0、无 1、有
                    sucklingPeriod: this.formData.sucklingPeriod,//是否哺乳期  0、无 1、有
                    injectionDiagnosisNo: this.formData.injectionDiagnosisNo.toString(),//诊断编号
                    injectionDiagnosisOther: this.formData.injectionDiagnosisOther,//诊断（其他）
                    injectionTreatment: this.formData.injectionTreatment.toString(),//注射治疗
                    treatmentOther: this.formData.treatmentOther,//注射治疗（其他）
                    injectionInspect: this.formData.injectionInspect,//注射前检查
                    // 注射部位
                    injectionType1: this.formData.injectionType1.toString(),//肉毒素注射
                    injectionTypeOther1: this.formData.injectionTypeOther1,//肉毒素注射（其他）
                    injectionType2: this.formData.injectionType2.toString(),//玻尿酸/胶原蛋白填充
                    injectionTypeOther2: this.formData.injectionTypeOther2,//玻尿酸/胶原蛋白填充（其他）
                    injectionType3: this.formData.injectionType3.toString(),//玻璃酸梅注射
                    injectionType4: this.formData.injectionType4.toString(),//嗨体注射
                    injectionTypeOther4: this.formData.injectionTypeOther4,//嗨体注射（其他）
                    injectionPosition: this.formData.injectionPosition,//注射位置（图片定位）
                    other: this.formData.other,
                    createBy: Lockr.get('skinEmpId'),
                }
                var formData = new FormData();
                formData.append("file", this.file)
                formData.append("sknCaseInjection", JSON.stringify(data))
                api.requestQuiet("/case/updateSknCaseInjection", formData, (res) => {
                    if (res.result == true) {
                        this.$emit("close");
                        this.$emit("add-comment");
                        _g.toast("success", '修改成功');
                    } else {
                        _g.toast("error", res.errMsg);
                    }
                }, (err) => { });
            })


        },
    }
}
</script>
<style scoped>
.injectImg {
  width: 300px;
}
.left {
  /* border: 1px solid red; */
  width: 65%;
}
.right {
  /* border: 1px solid blue; */
  width: 30%;
}
.injectFlex >>> .el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.flex {
  display: flex;
}
.card >>> .el-select .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
}
.little >>> .el-input {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.child >>> .el-form-item {
  margin-bottom: 3px !important;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
</style>


